module.exports = __webpack_public_path__ + "img/ocg.f3633f0a.png";